module.exports = __webpack_public_path__ + "img/0.2cb9da9a.png";